﻿import {PaymentMethodEditViewModel} from './paymentMethodEdit.viewmodel';
import * as Repositories from '../../repositories/repositories'
import * as Model from '../../models/models';
import * as _ from 'lodash';
import {IPaymentMethod} from "../../models/models";



export class PaymentMethodEditGateway {

    private numberOfAttempts: number = 0;
    private paymentMethodsHaveChanged: boolean = false;
    private deferred;
    private maximumAttempts = 240;
    private delayDuration: number = 500;

    static $inject = ['$q', '$log', '$timeout', 'policyholderRepository', 'paymentRepository'];

    constructor(private $q: ng.IQService,
        private $log: ng.ILogService,
        private $timeout: ng.ITimeoutService,
        private policyholderRepository: Repositories.PolicyholderRepository,
        private paymentRepository: Repositories.PaymentRepository) {
    }


    public loadPaymentMethodEditViewModel = (policyholderid: string): ng.IPromise<PaymentMethodEditViewModel> => {

        let paymentMethodEditViewModel = new PaymentMethodEditViewModel;

        return this.setPolicyholder(paymentMethodEditViewModel, policyholderid)
            .then((paymentMethodEditViewModel: PaymentMethodEditViewModel): ng.IPromise<PaymentMethodEditViewModel> => {
                return this.setPaymentMethods(paymentMethodEditViewModel);
            });
    };

    public setPaymentMethods = (paymentMethodEditViewModel: PaymentMethodEditViewModel): ng.IPromise<PaymentMethodEditViewModel> => {

        return this.$q.all([
            this.getCardPaymentMethods(paymentMethodEditViewModel).then((cardPaymentMethods: Array<Model.ICardPaymentMethod>) => paymentMethodEditViewModel.cardPaymentMethods = cardPaymentMethods),
            this.getEcheckPaymentMethods(paymentMethodEditViewModel).then((eCheckPaymentMethods: Array<Model.IEcheckPaymentMethod>) => paymentMethodEditViewModel.echeckPaymentMethods = eCheckPaymentMethods)
        ]).then(() => {
            this.setAutoPayToken(paymentMethodEditViewModel);
            return paymentMethodEditViewModel;
        });

    };

    public updateAutoPayToken = (paymentMethodEditViewModel: PaymentMethodEditViewModel): ng.IPromise<any> => {
        return this.paymentRepository.updateAutoPayToken(paymentMethodEditViewModel.selectedPaymentTokenId);
    };

    public updatePaymentMethods(paymentMethodEditViewModel: PaymentMethodEditViewModel):ng.IPromise<any> {

        let promises = [];

        _.forEach(paymentMethodEditViewModel.getPaymentMethods, (paymentMethod:IPaymentMethod)=>{

            if(paymentMethod.isDirty){

                promises.push(this.paymentRepository.updatePaymentMethod(paymentMethod));
            }
        });

        return this.$q.all(promises).then(()=>{
            return paymentMethodEditViewModel;
        })
    }

    private setAutoPayToken = (paymentMethodEditViewModel: PaymentMethodEditViewModel): ng.IPromise<PaymentMethodEditViewModel> => {
        const autoPayCardToken = _.find(paymentMethodEditViewModel.cardPaymentMethods, (cardPaymentMethod) => { return cardPaymentMethod.autopay });
        const autoPayEcheckToken = _.find(paymentMethodEditViewModel.echeckPaymentMethods, (echeckPaymentMethod) => { return echeckPaymentMethod.autopay });

        if (typeof (autoPayCardToken) != "undefined") {
            paymentMethodEditViewModel.selectedPaymentTokenId = autoPayCardToken.tokenId;
            return;
        }

        if (typeof (autoPayEcheckToken) != "undefined") {
            paymentMethodEditViewModel.selectedPaymentTokenId = autoPayEcheckToken.tokenId;
            return;
        }

    };

    private getCardPaymentMethods = (paymentMethodEditViewModel: PaymentMethodEditViewModel): ng.IPromise<Array<Model.ICardPaymentMethod>> => {
        return this.paymentRepository.getCardPaymentMethods(paymentMethodEditViewModel.policyholder.id)
            .then((cardPaymentMethods: Array<Model.ICardPaymentMethod>) => {
                return cardPaymentMethods;
            });
    };

    private getEcheckPaymentMethods = (paymentMethodEditViewModel: PaymentMethodEditViewModel): ng.IPromise<Array<Model.IEcheckPaymentMethod>> => {
        return this.paymentRepository.getEcheckPaymentMethods(paymentMethodEditViewModel.policyholder.id)
            .then((echeckPaymentMethods: Array<Model.IEcheckPaymentMethod>) => {
                return echeckPaymentMethods;
            });
    };

    private refreshPaymentMethods = (paymentMethodEditViewModel: PaymentMethodEditViewModel): ng.IPromise<any> => {

        if (this.numberOfAttempts < this.maximumAttempts && this.paymentMethodsHaveChanged === false) {

            let newCardPaymentMethods: Array<Model.ICardPaymentMethod>;
            let newEcheckPaymentMethods: Array<Model.IEcheckPaymentMethod>;

            let callChain1 = this.getCardPaymentMethods(paymentMethodEditViewModel)
                .then((cardPaymentMethods: Array<Model.ICardPaymentMethod>) => newCardPaymentMethods =
                    cardPaymentMethods);
            let callChain2 = this.getEcheckPaymentMethods(paymentMethodEditViewModel)
                .then((eCheckPaymentMethods: Array<Model.IEcheckPaymentMethod>) => newEcheckPaymentMethods =
                    eCheckPaymentMethods);

            this.$q.all([callChain1, callChain2])
                .then(() => {

                    this.numberOfAttempts = this.numberOfAttempts + 1;

                    let cardPaymentMethodsHaveChanged = !_.isEqual(newCardPaymentMethods, paymentMethodEditViewModel.cardPaymentMethods);
                    let echeckPaymentMethodsHaveChanged = !_.isEqual(newEcheckPaymentMethods, paymentMethodEditViewModel.echeckPaymentMethods);

                    if (cardPaymentMethodsHaveChanged || echeckPaymentMethodsHaveChanged) {
                        this.paymentMethodsHaveChanged = true;
                        paymentMethodEditViewModel.cardPaymentMethods = newCardPaymentMethods;
                        paymentMethodEditViewModel.echeckPaymentMethods = newEcheckPaymentMethods;
                        this.setAutoPayToken(paymentMethodEditViewModel);
                    }

                    this.$timeout(() => {
                        this.refreshPaymentMethods(paymentMethodEditViewModel);

                    }, this.delayDuration);
                });

        }
        if (this.numberOfAttempts >= this.maximumAttempts && this.paymentMethodsHaveChanged === false) {
            return this.deferred.reject("Maximum attempts reached");
        }

        if (this.paymentMethodsHaveChanged) {
            return this.deferred.resolve(true);
        }

    };

    private setPolicyholder = (paymentMethodEditViewModel: PaymentMethodEditViewModel, policyholderid: string): ng.IPromise<PaymentMethodEditViewModel> => {
        return this.policyholderRepository.getById(policyholderid)
            .then((policyholder: Model.IPolicyholder) => {
                paymentMethodEditViewModel.policyholder = policyholder;
                return paymentMethodEditViewModel;
            });
    };

}